import React from "react";
import Skeleton from "@mui/material/Skeleton";

/**
 * Placeholder shown in the Investing Essentials carousel/grid while
 * product-details are loading for the first time. Sized to match
 * MobileEssentialCard (176x176) and LockedProductCard/UnlockedProductCard
 * (minHeight 280/300) so real cards don't cause a layout shift on swap-in.
 */
const EssentialCardSkeleton = ({ compact = false }) => {
  if (compact) {
    return (
      <Skeleton
        variant="rounded"
        width={176}
        height={176}
        sx={{ borderRadius: "24px", flexShrink: 0, scrollSnapAlign: "start" }}
      />
    );
  }

  return (
    <Skeleton
      variant="rounded"
      sx={{
        borderRadius: "39px",
        height: "100%",
        minHeight: { xs: 280, md: 300 },
      }}
    />
  );
};

export default EssentialCardSkeleton;
